import { render, staticRenderFns } from "./PickersList.vue?vue&type=template&id=22f40748&"
import script from "./PickersList.vue?vue&type=script&lang=js&"
export * from "./PickersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports